<template>
  <BaseModal @close="$emit('close')">
    <template v-slot:title>
      <div class="modal-header-split">
        <span>Pedido #{{ pedido.id }}</span>
        <span :class="['status-badge', pedido.status]">
          {{ pedido.status | statusFilter }}
        </span>
      </div>
    </template>
    
    <div class="details-stack">
      
      <div class="detail-card">
        <h4><span class="material-icons-outlined">person</span> Cliente</h4>
        <div class="info-row">
          <span class="label">Nome:</span>
          <span class="value">{{ pedido.nome }}</span>
        </div>
        <div class="info-row">
          <span class="label">Telefone:</span>
          <span class="value">{{ pedido.telefone || '-' }}</span>
        </div>
      </div>
      
      <div class="detail-card">
        <h4><span class="material-icons-outlined">location_on</span> Entrega</h4>
        <div class="address-block">
          <p>
            {{ pedido.rua }}, {{ pedido.numero }}
            <span v-if="pedido.complemento">({{ pedido.complemento }})</span>
          </p>
          <p>
            <strong>{{ pedido.bairro }}</strong> - {{ pedido.cidade }}
          </p>
        </div>
      </div>
      
      <div class="detail-card">
        <h4><span class="material-icons-outlined">shopping_cart</span> Resumo da Compra</h4>
        <div class="info-row">
          <span class="label">Produto:</span>
          <span class="value">{{ pedido.produto ? pedido.produto.nome : 'Produto Removido' }}</span>
        </div>
        <div class="info-row">
          <span class="label">Quantidade:</span>
          <span class="value">{{ pedido.quantidade }} un.</span>
        </div>
        <div class="info-row total-row">
          <span class="label">Valor Total:</span>
          <span class="value price">R$ {{ pedido.valor_total ? pedido.valor_total.toFixed(2) : '0.00' }}</span>
        </div>
      </div>
      
      <div class="detail-meta">
        <div class="meta-item" title="Referência Externa">
          <span class="material-icons-outlined">fingerprint</span>
          <span class="code">{{ pedido.external_reference }}</span>
        </div>
        <div class="meta-item" title="Data de Criação">
          <span class="material-icons-outlined">event</span>
          <span>{{ formatDate(pedido.created_at) }}</span>
        </div>
      </div>
    
    </div>
    
    <template v-slot:actions>
      <button @click="$emit('close')" class="modal-btn-no">Fechar</button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';

export default {
  name: "ModalDetalhesPedido",
  components: { BaseModal },
  props: {
    pedido: { type: Object, required: true }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '-';
      return new Date(dateStr).toLocaleString('pt-BR');
    }
  },
  filters: {
    statusFilter(value) {
      const map = {
        created: 'criado', approved: 'aprovado', pending: 'pendente', in_process: 'em análise',
        cancelled: 'cancelado', rejected: 'rejeitado', out_of_stock: 'sem estoque',
        failure: 'falhou', expired: 'expirado', delivered: 'entregue', refunded: 'reembolsado'
      };
      return map[value] || value;
    }
  }
};
</script>

<style scoped>
.modal-header-split { display: flex; justify-content: space-between; align-items: center; width: 100%; padding-right: 35px; }
.details-stack { display: flex; flex-direction: column; gap: 15px; padding: 5px 0; box-sizing: border-box; width: 100%; }

.detail-card {
  box-sizing: border-box; background-color: var(--bg-main); border: 1px solid var(--border-light);
  border-radius: 8px; padding: 15px; display: flex; flex-direction: column; gap: 8px;
  position: relative; overflow: hidden; width: 100%;
}

.detail-card h4 {
  margin: 0 0 5px 0; font-size: 0.85rem; text-transform: uppercase; color: var(--text-secondary);
  display: flex; align-items: center; gap: 8px; border-bottom: 1px solid var(--border-light);
  padding-bottom: 8px; font-weight: 700;
}
.detail-card h4 .material-icons-outlined { font-size: 20px; color: var(--color-accent); }

.info-row { display: flex; justify-content: space-between; align-items: flex-start; font-size: 0.95rem; line-height: 1.4; margin-bottom: 4px; }
.info-row .label { color: var(--text-secondary); font-weight: 500; white-space: nowrap; flex-shrink: 0; margin-right: 10px; }
.info-row .value { color: var(--text-main); font-weight: 600; text-align: right; word-break: break-word; flex: 1; }

.address-block p { margin: 0 0 4px 0; font-size: 1rem; line-height: 1.4; color: var(--text-main); }
.total-row { margin-top: 5px; padding-top: 8px; border-top: 1px dashed var(--border-light); font-size: 1.2rem; }
.value.price { color: var(--color-accent); font-weight: 800; }

.detail-meta {
  box-sizing: border-box; display: flex; flex-direction: column; gap: 10px; font-size: 0.8rem;
  color: var(--text-secondary); margin-top: 5px; background-color: rgba(128, 128, 128, 0.05);
  padding: 10px; border-radius: 6px; border: 1px solid var(--border-light); width: 100%;
}
.meta-item { display: flex; align-items: center; gap: 8px; }
.meta-item .material-icons-outlined { font-size: 18px; opacity: 0.7; }
.code { font-family: monospace; background: rgba(0, 0, 0, 0.1); padding: 2px 5px; border-radius: 3px; }

.status-badge {
  padding: 4px 10px; border-radius: 12px; font-size: 0.8rem; font-weight: bold; text-transform: uppercase; display: inline-block;
}
/* Recriar classes de status (copiadas do admin-styles para garantir que funcionem dentro do scoped) */
.status-badge.approved { background: #4caf50; color: #fff; }
.status-badge.pending { background: #ff9800; color: #000; }
.status-badge.in_process { background: #ff9800; color: #000; }
.status-badge.created { background: #2196f3; color: #fff; }
.status-badge.cancelled, .status-badge.rejected { background: #f44336; color: #fff; }
.status-badge.out_of_stock, .status-badge.expired { background: #9E9E9E; color: #000; }
.status-badge.delivered { background: #8834f1; color: #fff; }
.status-badge.rejected { background: #000; color: #9E9E9E; }
.status-badge.failure { background: #000; color: #9E9E9E; }
.status-badge.refunded { background: #000; color: #ff8929; }

.modal-btn-no {
  padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; font-size: 1rem;
  background-color: var(--bg-icon-button); color: var(--text-main); border: 1px solid var(--border-light);
}
.modal-btn-no:hover { background-color: var(--bg-icon-button-hover); }

@media (max-width: 600px) {
  .detail-meta { flex-direction: column; gap: 10px; }
}
</style>